import { motion } from "framer-motion";
import ProjectGallery from "../ProjectGallery";

const FEATURES = [
  "Register services, repairs, and maintenance events",
  "Track mileage and maintenance intervals",
  "Keep a complete service history in one place",
  "Designed for offline use with a mobile-first experience",
];

const TECH = ["React Native", "Expo", "TypeScript", "SQLite", "Android"];

export default function FeaturedProject() {
  return (
    <section
      id="projects"
      className="border-t border-white/[0.06] bg-[#060B14] px-6 py-24 text-white sm:py-32"
    >
      <div className="mx-auto max-w-6xl">
        <div className="grid items-center gap-16 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="mt-5 text-5xl font-medium tracking-[-0.05em] sm:text-6xl">
              MotoLog
            </h2>

            <p className="mt-6 max-w-xl text-base leading-8 text-white/45 sm:text-lg">
              A mobile application for motorcycle owners to keep track of
              maintenance, repairs, mileage, and service history in one place.
            </p>

            <ul className="mt-8 space-y-3">
              {FEATURES.map((feature) => (
                <li
                  key={feature}
                  className="flex gap-3 text-sm leading-6 text-white/50"
                >
                  <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-white/25" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex items-center gap-6">
              <a
                href="https://play.google.com/store/apps/details?id=com.soycherusorganization.motolog"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2 text-sm font-medium text-white transition"
              >
                View project
                <span className="text-white/30 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5">
                  ↗
                </span>
              </a>

              <a
                href="https://github.com/cherubinifranco/motolog"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2 text-sm font-medium text-white/35 transition hover:text-white"
              >
                Source code
                <span className="text-white/20 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5">
                  ↗
                </span>
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30, scale: 0.96 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{
              duration: 0.9,
              ease: "easeOut",
            }}
            className="relative flex min-h-[500px] items-center justify-center lg:min-h-[600px]"
          >
            <div className="relative">
              <ProjectGallery />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
